/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { AnyAction } from '@reduxjs/toolkit';

import { MessagesSlice } from '../../../../ts/state';
import { getInstance } from '../instance/actions';
import * as types from './actionTypes';

const initialState = {
  messages: [],
  accessDenied: false
};

const addMessage = (state: MessagesSlice, { message }: AnyAction) => ({
  ...state,
  messages: [...state.messages, message]
});

const removeMessage = (state: MessagesSlice, { key }: AnyAction) => {
  return {
    ...state,
    messages: state.messages.filter(item => item.key !== key)
  };
};

const overrideMessage = (state: MessagesSlice, { message }: AnyAction) => ({
  ...state,
  messages: Array.isArray(message) ? [...message] : [message]
});

const accessDenied = (state: MessagesSlice) => ({
  ...state,
  messages: [],
  accessDenied: true
});

export const reducer = (
  state: MessagesSlice = initialState,
  action: AnyAction
) => {
  switch (action.type) {
    case types.ADD_MESSAGE:
      return addMessage(state, action);
    case types.REMOVE_MESSAGE:
      return removeMessage(state, action);
    case types.OVERRIDE_MESSAGE:
      return overrideMessage(state, action);
    case types.ACCESS_DENIED:
      return accessDenied(state);
    case getInstance.rejected.type:
      return accessDenied(state);
    default:
      return state;
  }
};

export default reducer;
